module.exports = __webpack_public_path__ + "img/advisory2.c0ccc9e6.svg";